import React, { Component } from 'react';
import { connect } from 'react-redux';

import CodeGroup from './CodeGroup';
import { alertActions } from '../../modules/alert';

class CodeMng extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completed: 0,
            searchKeyword: '',
        }
    }

    stateRefresh = () => {
        this.setState({
            completed: 0,
            searchKeyword: '',
        });
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }

    render() {
        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    코드 관리
                </h2>
                <div className="search-wrapper s-normal-box">
                    <input
                        placeholder="코드 검색"
                        className="input-box w100per"
                        name="searchKeyword"
                        value={this.state.searchKeyword}
                        onChange={this.handleValueChange}
                    />
                </div>
                {this.props.codes && this.props.groupCodes.map((groupCode, i) => {
                    return <CodeGroup key={i} stateRefresh={this.stateRefresh} groupCode={groupCode.code} groupCodeName={groupCode.name}  groupCodes={this.props.groupCodes} codes={this.props.codes} searchKeyword={this.state.searchKeyword}/>;
                })
                }
            </React.Fragment>
        );
    }
}

function mapState(state) {
    const { codemng } = state;
    const { groupCodes, codes } = codemng;
    return { groupCodes, codes };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(CodeMng);